/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const PartyStatus = {
  DUPLICATED: 'DUPLICATED',
  CONFIRMED: 'CONFIRMED',
  SKIPPED: 'SKIPPED',
};
